import EDataTable1 from './EDataTable1'

export default EDataTable1
